import { EventEmitter, Injectable } from '@angular/core';
import { HttpService, Search } from '@docpath/linces-angular-components/common';
import { DpButtonStateIcon, DpFieldButton, DpModalService } from '@docpath/webcomponents';

import { EndPoints } from '../../../../constants/end-points';
import { IndexService } from '../models/index-service';


@Injectable({
    providedIn: 'root'
})
export class IndexServicesHttpService {

    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_INDEX_SERVICES}`;
    private readonly toastPrefix = 'services-config.index-services.toast';

    showLoadingChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private readonly httpService: HttpService,
        private readonly modalService: DpModalService
    ) { }

    createIndexService(indexService: IndexService, suscribe: () => void): void {
        this.httpService.post(indexService, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            catchError: (statusCode, message, messageParameters) => this.processIndexServiceError(message, messageParameters, indexService, `${this.toastPrefix}.create-success`, suscribe),
            toast: `${this.toastPrefix}.create-success`
        });
    }

    overriteIndexService(indexService: IndexService, toast: string, suscribe: () => void): void {
        this.httpService.post(indexService, {
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_CONFIGURATION_INDEX_SERVICES_OVERRIVE}`,
            loading: true,
            suscribe,
            toast
        });
    }

    deleteIndexServices(indexServiceIds: number[], suscribe: () => void): void {
        this.httpService.delete({
            relativeUrl: `${this.relativeUrl}`,
            queryParameters: { ids: indexServiceIds },
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.delete-success`
        });
    }

    getIndexServices(search: Search, suscribe: (result: IndexService[], totalSize: number) => void): void {
        const searchBase64 = btoa(JSON.stringify(search));
        this.showLoadingChanged.emit(true);

        this.httpService.get({
            relativeUrl: this.relativeUrl,
            queryParameters: { search: searchBase64 },
            suscribe: response => {
                const responseBody = response.result as unknown as Search,
                    result = responseBody.result as IndexService[],
                    totalSize = responseBody.paginator?.totalSize ?? 0;
                this.showLoadingChanged.emit(false);
                suscribe(result, totalSize);
            },
            suscribeOnError: () => {
                this.showLoadingChanged.emit(false);
            }
        });
    }

    editIndexService(indexService: IndexService, suscribe: () => void): void {
        this.httpService.put(indexService, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            catchError: (statusCode, message, messageParameters) => this.processIndexServiceError(message, messageParameters, indexService, `${this.toastPrefix}.update-success`, suscribe),
            toast: `${this.toastPrefix}.update-success`
        });
    }

    updateIndexServices(indexServiceIds: number[], suscribe: () => void): void {
        this.httpService.put(indexServiceIds, {
            relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_CONFIGURATION_INDEX_SERVICES_UPDATE}`,
            queryParameters: { ids: indexServiceIds },
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.update-success`
        });
    }

    testConnection(testButton: DpFieldButton, queryParameters: Record<string, unknown>): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.httpService.get({
                relativeUrl: `${this.relativeUrl}/${EndPoints.ENDPOINT_CONFIGURATION_INDEX_SERVICES_CONNECTION}`,
                queryParameters,
                loading: false,
                suscribe: response => {
                    testButton.state = response.result ? DpButtonStateIcon.Success : DpButtonStateIcon.Error;
                    resolve();
                },
                suscribeOnError: error => {
                    testButton.state = DpButtonStateIcon.Error;
                    reject(error);
                }
            });
        });
    }

    private processIndexServiceError(message: string, messageParameters: Record<string, string> | undefined, indexService: IndexService, toast: string, suscribe: () => void): void {
        if (message === 'linces.http.error.index-services.credentials') {
            const modal = this.modalService.openQuestion('linces.http.error.index-services.credentials');
            modal.componentInstance.accepted.subscribe(() => this.overriteIndexService(indexService, toast, suscribe));
        } else {
            this.modalService.openError(message, messageParameters);
        }
    }

}